var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isExclude ? 'label-check excluded' : 'label-check'},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.showCheck)?_c('b-checkbox',{staticClass:"checkbox",on:{"input":_vm.onItemToExclude},model:{value:(_vm.isExclude),callback:function ($$v) {_vm.isExclude=$$v},expression:"isExclude"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }